export default "__VITE_ASSET__C0OX30yD__"